export const toUiRow = (row) => ({
  id: row.row_key,
  rowKey: row.row_key,
  module: row.module,
  veevaCRM: row.veeva_crm_field,
  vaultCRM: row.vault_crm_field,
  enabled: row.enabled,
  status: row.status,
  confidence: row.confidence,
  notes: row.notes || "",
  mappingType: row.mapping_type || "custom",
  source: row.source || "import",
  sourceFile: row.source_file || "",
  createdAt: row.created_at,
  updatedAt: row.updated_at,
  lastSeenAt: row.last_seen_at,
});

export const toApiRow = (row, userName) => ({
  row_key: row.rowKey,
  module: row.module,
  veeva_crm_field: row.veevaCRM,
  vault_crm_field: row.vaultCRM,
  mapping_type: row.mappingType || "custom",
  source: row.source || "manual",
  source_file: row.sourceFile || "manual-entry",
  enabled: row.enabled,
  status: row.status || "active",
  confidence: typeof row.confidence === "number" ? row.confidence : 1,
  notes: row.notes || "",
  imported_by: userName,
  created_at: row.createdAt || new Date().toISOString(),
  updated_at: row.updatedAt || new Date().toISOString(),
  last_seen_at: row.lastSeenAt || new Date().toISOString(),
});

export const slugifyModuleName = (value) =>
  (value || "module")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "module";

export const toProcessUiRow = (row) => {
  const processStatement = row.process_text || row.processText || row.updated_text || row.updatedText || "";
  const hasExplicitVocabularyText = Object.prototype.hasOwnProperty.call(row, "vocabulary_text")
    || Object.prototype.hasOwnProperty.call(row, "vocabularyText");
  const explicitVocabularyText = (row.vocabulary_text ?? row.vocabularyText ?? "");
  const vocabularyStatement = hasExplicitVocabularyText
    ? explicitVocabularyText
    : processStatement;

  const hasExplicitVocabularyCells = Object.prototype.hasOwnProperty.call(row, "vocabulary_cells")
    || Object.prototype.hasOwnProperty.call(row, "vocabularyCells");
  const explicitVocabularyCells = Array.isArray(row.vocabulary_cells)
    ? row.vocabulary_cells
    : (Array.isArray(row.vocabularyCells) ? row.vocabularyCells : []);

  const processCells =
    Array.isArray(row.process_cells) && row.process_cells.length > 0
      ? row.process_cells
      : Array.isArray(row.processCells) && row.processCells.length > 0
        ? row.processCells
        : Array.isArray(row.updated_cells)
          ? row.updated_cells
          : Array.isArray(row.updatedCells)
            ? row.updatedCells
            : [];

  const vocabularyCells = hasExplicitVocabularyCells
    ? explicitVocabularyCells
    : processCells;

  return {
    id: row.id || row.row_id,
    moduleId: slugifyModuleName(row.module_name || row.moduleName),
    moduleName: row.module_name || row.moduleName,
    veevaStatement: row.original_text || row.originalText || "",
    processStatement,
    vocabularyStatement,
    finalStatement:
      row.final_text || row.finalText || row.vocabulary_text || row.vocabularyText || processStatement || "",
    rowKind: row.row_kind || row.rowKind,
    rowNumber: row.row_number ?? row.rowNumber,
    sourceRef: row.source_ref || row.sourceRef || "",
    originalCells: Array.isArray(row.original_cells) ? row.original_cells : (Array.isArray(row.originalCells) ? row.originalCells : []),
    processCells,
    vocabularyCells,
    finalCells:
      Array.isArray(row.final_cells) && row.final_cells.length > 0
        ? row.final_cells
        : Array.isArray(row.finalCells) && row.finalCells.length > 0
          ? row.finalCells
          : Array.isArray(row.vocabulary_cells)
            ? row.vocabulary_cells
            : Array.isArray(row.vocabularyCells)
              ? row.vocabularyCells
              : processCells,
    edited: row.edited === true,
  };
};

export const toProcessSourceRowFromDocument = (row) => {
  const sourceCells = Array.isArray(row.cells) ? row.cells.map((cell) => String(cell ?? "")) : [];
  const sourceText = String(row.text ?? "");
  return {
    id: row.row_id,
    moduleId: "document-content",
    moduleName: "Document Content",
    veevaStatement: sourceText,
    processStatement: "",
    vocabularyStatement: "",
    finalStatement: "",
    rowKind: row.row_kind,
    rowNumber: Number(row.row_number) || 0,
    sourceRef: row.structure_ref || "",
    originalCells: sourceCells,
    processCells: [],
    vocabularyCells: [],
    finalCells: [],
    edited: false,
  };
};

export const toComparisonApiRow = (row) => ({
  id: row.id,
  row_number: row.rowNumber,
  row_kind: row.rowKind,
  module_name: row.moduleName,
  source_ref: row.sourceRef || "",
  original_text: row.veevaStatement || "",
  updated_text: row.processStatement || "",
  original_cells: Array.isArray(row.originalCells) ? row.originalCells : [],
  updated_cells: Array.isArray(row.processCells) ? row.processCells : [],
  process_text: row.processStatement || "",
  process_cells: Array.isArray(row.processCells) ? row.processCells : [],
  vocabulary_text: row.vocabularyStatement || row.processStatement || "",
  vocabulary_cells: Array.isArray(row.vocabularyCells)
    ? row.vocabularyCells
    : Array.isArray(row.processCells)
      ? row.processCells
      : [],
  final_text: row.finalStatement || row.vocabularyStatement || row.processStatement || "",
  final_cells: Array.isArray(row.finalCells)
    ? row.finalCells
    : Array.isArray(row.vocabularyCells)
      ? row.vocabularyCells
      : [],
  edited: row.edited === true,
});
